import React from 'react';
import { cn } from '@/lib/utils';
import { formatCurrency } from '@/lib/portfolioCalculations';

interface CurrencyAmountProps {
  value: number | null | undefined;
  currency: string;
  showCurrency?: boolean;
  className?: string;
  showDecimals?: boolean;
  locale?: string;
}

export function CurrencyAmount({
  value,
  currency,
  showCurrency = false,
  className,
  showDecimals = true,
  locale,
}: CurrencyAmountProps) {
  const text = typeof value === 'number'
    ? (
        showCurrency
          ? formatCurrency(value, currency, { showDecimals, locale, showCurrency: true })
          : new Intl.NumberFormat(locale, {
              minimumFractionDigits: showDecimals ? 2 : 0,
              maximumFractionDigits: showDecimals ? 2 : 0,
            }).format(value)
      )
    : '—';

  return (
    <span className={cn('font-mono tabular-nums', className)}>{text}</span>
  );
}
